export default "__VITE_ASSET__CX7grXJd__"